import moment from "moment";

const initialState = {
  selectedDateFilter: {
    fromDate: new Date(moment().startOf("month")).getTime() + 19800000,
    toDate: new Date().getTime(),
  },
};
export default initialState;
